import React from "react";
import { useDispatch } from "react-redux";
import { Form } from "semantic-ui-react";

import * as actions from "../../../store/actions/actions";
import { reportTypes } from "../../../store/reducers/reports";

const ReportsSidePanelStores = (props) => {
  const { type, stores, selectedStores } = props;

  const dispatch = useDispatch();

  const clickHandler = (event, data) => {
    dispatch(actions.clickStore(data.value));
  };

  const selectHandler = (event, data) => {
    dispatch(actions.selectStore(data.value));
  };

  return (
    <div className="reports-panel-stores">
      <div className="reports-panel-section-title">
        {type === reportTypes.compareStores.value ||
        type === reportTypes.analyzeRecentTrends.value
          ? "Select Stores"
          : "Select Store"}
      </div>
      <Form.Group grouped>
        {stores.map((a, index) =>
          type === reportTypes.compareStores.value ||
          type === reportTypes.analyzeRecentTrends.value ? (
            <Form.Checkbox
              key={index}
              label={a.NAME}
              name="stores"
              type="checkbox"
              value={a.ID}
              disabled={
                selectedStores.length === 6 && !selectedStores.includes(a.ID)
              }
              checked={selectedStores.includes(a.ID)}
              onChange={selectHandler}
            />
          ) : (
            <Form.Radio
              key={index}
              label={a.NAME}
              name="stores"
              type="radio"
              value={a.ID}
              checked={selectedStores.includes(a.ID)}
              onChange={clickHandler}
            />
          )
        )}
      </Form.Group>
    </div>
  );
};

export default React.memo(ReportsSidePanelStores);
